import { jsxs as l, jsx as C } from "react/jsx-runtime";
import { getIconStyles as i } from "../styles.js";
const d = (e) => /* @__PURE__ */ l(
  "svg",
  {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: i(e),
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_3629_30459)", children: [
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.71764 0.515795C1.77956 0.666083 1.0628 1.3167 0.831365 2.228C0.786821 2.40335 0.785645 2.63029 0.785645 11C0.785645 19.3744 0.786797 19.5966 0.831437 19.772C1.04324 20.6048 1.66887 21.2304 2.50164 21.4422C2.67384 21.486 2.80743 21.488 5.58564 21.488H8.48964L8.59272 21.433C8.75168 21.3481 8.8777 21.221 8.95083 21.0719C9.04272 20.8844 9.04556 20.6095 8.95738 20.4351C8.87787 20.2779 8.73358 20.1377 8.57364 20.0623L8.44164 20L2.82564 19.976L2.71236 19.9237C2.55519 19.8511 2.39525 19.6792 2.33496 19.5181L2.28538 19.3855L2.29764 2.528L2.35263 2.42502C2.4229 2.29345 2.56709 2.14926 2.69866 2.07899L2.80164 2.024H8.33364C13.7201 2.024 13.8682 2.0252 13.9616 2.06963C14.1016 2.13613 17.1163 5.14727 17.1929 5.29698L17.2496 5.408L17.2736 8.168L17.3359 8.3C17.4114 8.45994 17.5515 8.60423 17.7088 8.68374C17.8832 8.77191 18.158 8.76908 18.3455 8.67719C18.4946 8.60406 18.6217 8.47803 18.7066 8.31908L18.7616 8.216V6.74C18.7616 5.28399 18.7609 5.26124 18.7075 5.06077C18.6387 4.80287 18.4763 4.46874 18.3221 4.268C18.138 4.02843 15.0669 0.980363 14.9023 0.873803C14.7124 0.750947 14.4405 0.628067 14.2184 0.564707L14.0336 0.512003L8.40564 0.509099C5.31024 0.507491 2.75064 0.510515 2.71764 0.515795ZM16.1216 10.2581C15.2297 10.3468 14.5957 10.52 13.8896 10.8676C12.1258 11.736 10.9047 13.3977 10.5999 15.344C10.5413 15.7181 10.5281 16.525 10.5742 16.9201C10.662 17.6733 10.8281 18.236 11.1647 18.92C11.799 20.209 12.8958 21.233 14.2503 21.8009C14.7543 22.0122 15.3562 22.1631 15.9271 22.2212C16.3311 22.2622 17.1416 22.2387 17.5136 22.1751C18.4287 22.0187 19.3439 21.6381 20.0385 21.125L20.2113 20.9974L21.9105 22.6985C23.5302 24.3202 23.6161 24.4021 23.7486 24.4499C24.1344 24.5891 24.526 24.4278 24.7045 24.056C24.7915 23.8748 24.7976 23.6793 24.7227 23.4749C24.6745 23.3432 24.5845 23.2485 22.977 21.6377C21.6844 20.3425 21.2879 19.9318 21.3059 19.907C21.6452 19.4417 21.9595 18.8744 22.1489 18.3856C22.2803 18.0464 22.4251 17.4891 22.4839 17.096C22.5375 16.7375 22.545 15.8428 22.4972 15.5C22.2353 13.6194 21.2131 12.0602 19.6076 11.0922C18.9469 10.6939 18.1942 10.4277 17.3816 10.3049C17.1405 10.2684 16.3228 10.2381 16.1216 10.2581ZM15.9536 11.7934C14.2206 12.0274 12.7594 13.2575 12.2485 14.9124C12.1027 15.3849 12.0506 15.7417 12.0509 16.265C12.0512 16.6803 12.0928 17.0201 12.1867 17.372C12.5343 18.6759 13.3949 19.7183 14.6049 20.3009C15.6538 20.806 16.8399 20.8816 17.9447 20.5138C19.1352 20.1175 20.105 19.2496 20.6192 18.1206C21.098 17.0692 21.1619 15.9132 20.8009 14.8325C20.3044 13.346 19.0426 12.2043 17.5238 11.8675C17.0093 11.7534 16.4465 11.7268 15.9536 11.7934Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.74679 7.26927C3.74679 6.85506 4.08258 6.51927 4.49679 6.51927H14.9968C15.411 6.51927 15.7468 6.85506 15.7468 7.26927C15.7468 7.68348 15.411 8.01927 14.9968 8.01927H4.49679C4.08258 8.01927 3.74679 7.68348 3.74679 7.26927Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.74679 11.7693C3.74679 11.3551 4.08258 11.0193 4.49679 11.0193H8.24679C8.661 11.0193 8.99679 11.3551 8.99679 11.7693C8.99679 12.1835 8.661 12.5193 8.24679 12.5193H4.49679C4.08258 12.5193 3.74679 12.1835 3.74679 11.7693Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.74679 16.2693C3.74679 15.8551 4.08258 15.5193 4.49679 15.5193H8.24679C8.661 15.5193 8.99679 15.8551 8.99679 16.2693C8.99679 16.6835 8.661 17.0193 8.24679 17.0193H4.49679C4.08258 17.0193 3.74679 16.6835 3.74679 16.2693Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_3629_30459", children: /* @__PURE__ */ C(
        "rect",
        {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0.773438 0.5)"
        }
      ) }) })
    ]
  }
);
export {
  d as OcrIcon
};
//# sourceMappingURL=OcrIcon.js.map
